module.exports = __webpack_public_path__ + "assets/img/bigbank-logo.1d127d62.png";